import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import Image from 'components/Image';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';

export const STestimonialCard = styled.div`
  height: 100%;
  position: relative;
`;

export const STestimonialItem = styled(Col)`
  background-color: #fff;
  border-radius: 5px;
  // width: 25%;
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 10%), 0 4px 6px -2px rgb(0 0 0 / 5%);
  padding: 30px 20px 60px;
  height: 100%;
`;

export const STestimonialPosition = styled.div`
  color: ${props => props.theme.colors.accent}!important;
  font-size: 14px;
`;
export const STestimonialImage = styled(Image)`
  height: 90px;
  width: 90px;
  border-radius: 100%;
  color: #fff;
`;

export const STestimonialImageStar = styled.div`
  height: 120px;
  svg {
    height: 150px !important;
    width: 150px !important;
  }
`;

export const STestimonialCardFooter = styled.div`
  position: absolute;
  bottom: -70px;
  left: 0px;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 800;
`;

export const STestimonialAuthor = styled.div`
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const STestimonialText = styled.p`
  color: ${props => props.theme.colors.dark_grey}!important;
  text-align: center;
  font-size: 13px;
`;

export const STestimonialRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  ${mediaBreakpointDown(
    'lg',
    `
  grid-template-columns: 100%;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  grid-gap: 125px;
  
  `,
  )}
  ${mediaBreakpointDown(
    'md',
    `
  grid-gap: 135px;
  
  `,
  )}
  justify-content: center;
  align-items: center;
  grid-gap: 20px;
`;
